import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/activities?accountID=${accountID}`
      }))
  );
}

async function getById(activityID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/activities/${activityID}`
      }))
  );
}

async function getParentActitivies(accountID, activityID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/Activities/ParentActivities/${accountID}${activityID ? `?activityID=${activityID}` : ''}`
      }))
  );
}

async function create(activity) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/activities',
        body: JSON.stringify(activity)
      }))
  );
}

async function update(activity) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/activities/${activity.activityID}`,
        body: JSON.stringify(activity)
      }))
  );
}

// lowercase delete is a reserved word in javascript
async function Delete(activityID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/activities/${activityID}`
      }))
  );
}

const activityService = {
  getAll,
  getById,
  getParentActitivies,
  create,
  update,
  delete: Delete
};

export default activityService;
